/**
 * CVO Inbox View
 * Displays inbox notifications for CVO role
 */

import React from 'react';

const InboxView = ({ 
  inboxNotifications = [], 
  onNotificationClick 
}) => {
  return (
    <div className="h-full flex flex-col">
      <div className="bg-white rounded-xl shadow-lg border border-gray-100 h-full flex flex-col">
        <div className="flex-1 overflow-y-auto">
          {inboxNotifications.length === 0 ? (
            <div className="flex items-center justify-center h-64">
              <div className="text-center">
                <svg className="w-16 h-16 text-gray-400 mx-auto mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
                <p className="text-gray-500">No notifications</p>
              </div>
            </div>
          ) : (
            inboxNotifications.map((notification) => (
              <div
                key={notification.id}
                onClick={() => onNotificationClick && onNotificationClick(notification)}
                className={`px-6 py-4 border-b border-gray-100 hover:bg-gray-50 transition-colors duration-200 cursor-pointer ${!notification.read ? 'bg-blue-50' : ''}`}
              >
                <div className="flex justify-between items-start">
                  <div className="flex-1">
                    <p className="text-sm text-gray-900">{notification.message}</p>
                    <div className="flex items-center mt-2 space-x-4">
                      <span className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${
                        notification.type === 'assignment' ? 'bg-green-100 text-green-800' :
                        notification.type === 'redirection' ? 'bg-orange-100 text-orange-800' :
                        notification.type === 'internal_note' ? 'bg-purple-100 text-purple-800' :
                        'bg-blue-100 text-blue-800'
                      }`}>
                        {notification.type === 'assignment' ? 'Assignment' :
                         notification.type === 'redirection' ? 'Redirection' :
                         notification.type === 'internal_note' ? 'Internal Note' :
                         'Notification'}
                      </span>
                      <span className="text-xs text-gray-500">From: {notification.from}</span>
                      {notification.complaint_no && (
                        <span className="text-xs text-gray-500">Complaint: {notification.complaint_no}</span>
                      )}
                      {!notification.read && (
                        <span className="inline-flex px-2 py-1 text-xs font-semibold rounded-full bg-red-100 text-red-800">
                          New
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="text-right">
                    <p className="text-sm text-gray-500">{notification.date}</p>
                  </div>
                </div>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
};

export default InboxView;

